export default __webpack_public_path__ + "static/media/rare1.9f686dcb.gif";